import * as React from 'react'

function SvgMultipleDamageIcon(props) {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm8 7a7 7 0 1 1 0-14 7 7 0 0 1 0 14Zm-3.964-7.976V8h1.68v3.024l-.24 2.088h-1.2l-.24-2.088ZM8 13.976v1.704h1.764v-1.704H8Zm3.036-2.952V8h1.68v3.024l-.24 2.088h-1.2l-.24-2.088ZM11 13.976v1.704h1.764v-1.704H11Zm3.036-2.952V8h1.68v3.024l-.24 2.088h-1.2l-.24-2.088ZM14 13.976v1.704h1.764v-1.704H14Z"
        fill="#E91630"
      />
    </svg>
  )
}

export default SvgMultipleDamageIcon
